import React, { useState } from "react";
import image from "../../../asserts/promotion_image.png";
import "../../../App.css";
import dayjs from "dayjs";
import userimg from "../../../asserts/userprofile.png";
import NOIMAGE from "../../../asserts/NOIMAGE.png";
import { Popover, Modal } from "antd";
import {
  faEdit,
  faEllipsisVertical,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DeleteList from "../DeleteList";
import ModalPopup from "../../Common/Modal/Modal";
import { FaEye } from "react-icons/fa";
import { CiImageOff } from "react-icons/ci";
import { MdDelete, MdEdit } from "react-icons/md";
import { capitalizeFirstLetter } from "../../Common/Captilization";
import NoData from "../../../asserts/no data.png";

export default function GridView({
  currentData,
  setModalIsOpen,
  SetUpdateData,
  offerimage,
  setOfferImage,
  setOfferView,
  offerview,
  setValueSymbol,
  offerFilter,
  view,
  setUsageCount
}) {
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;
  const loadCrud = () => {
  const raw = sessionStorage.getItem("crud_permission");
  if (!raw) {
    return ["create", "view", "update", "delete"];
  }
  return raw
    .split(",")
    .map(x => x.trim())
    .filter(Boolean);
};
const crud = loadCrud();
const canCreate = crud?.includes("create");
const canView   = crud?.includes("view");
const canUpdate = crud?.includes("update");
const canDelete = crud?.includes("delete");
  const [promotionid, setPromoId] = useState(null);
  const [hoverid, setHoverId] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const [deletemodalIsOpen, setDeleteModalIsOpen] = useState(false);
  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
  };
  const typeId = sessionStorage.getItem("type_id");

  const [openPopovers, setOpenPopovers] = useState({});

  console.log(offerimage, "grid_offferimaeg");
  // Function to handle popover visibility based on offer ID
  const handlePopoverToggle = (offerId) => {
    setOpenPopovers((prevState) => ({
      ...prevState,
      [offerId]: !prevState[offerId], // Toggle the popover for this specific offerId
    }));
  };

  // Function to close the popover when any option is clicked
  const handleOptionClick = (offerId) => {
    setOpenPopovers((prevState) => ({
      ...prevState,
      [offerId]: false, // Close the popover when an option is clicked
    }));
  };
console.log(currentData,"CurrentData")
  return (
    <>
    <div className="pt-[0.5vw]">
      {currentData.length>0 ? ( 
      <div className="grid grid-cols-5 w-full gap-x-[4vw] gap-[0.75vw]">
        {currentData.length > 0 &&
        currentData.map((item) => (
          <div
            className={` bg-white text-[#1f4b7f] h-[16vw] relative border-[#1f4b7f] border-l-[0.1vw] cursor-default border-r-[0.3vw] border-b-[0.3vw] border-t-[0.1vw] rounded-[0.5vw]`}
            onMouseEnter={() => setHoverId(item.tbs_offer_id)}
            onMouseLeave={() => setHoverId("")}
            style={{
              transition: "ease-in 0.2s",

              boxShadow:
                hoverid === item.tbs_offer_id
                  ? "0.5vw 0.5vw 0.5vw #1f4b7f"
                  : "none",
            }}
          >
            <div className="flex justify-end pt-[1vw] pr-[.5vw]">
              <Popover
                placement="bottomRight"
                content={
                  <div className="flex flex-col border-[.1vw] border-[#1F487C] rounded-[.5vw] px-[0.5vw]">
                    <div className=" items-center gap-x-[0.5vw] py-[0.25vw] border-b-[0.1vw] border-[#1F487C]">
                      <span>
                        {/* <MdEdit
                          size={"1.2vw"}
                          color="#1F4B7F"
                          className=" cursor-pointer"
                        /> */}

                        {typeId === "PROEMP101" ? (
                          item.status_id === 0 || item.status_id === 1 ? (
                            <div onClick={() => {
                              if(!canUpdate) return;
                              setModalIsOpen(true);
                              SetUpdateData(item.tbs_offer_id);
                              handleOptionClick(item.tbs_offer_id);
                              setUsageCount(item?.offerusedcount)
                            }} className="flex items-center gap-x-[0.5vw]">
                              <div >
                                <MdEdit
                                  size={"1.2vw"}
                                  color="#1F4B7F"
                                  className={`${canUpdate ? "cursor-pointer" : "cursor-not-allowed"}`}
                                />
                              </div>
                              <div>
                                <a
                                  className={`flex font-semibold items-center cursor-pointer text-[1vw] text-[#1F4B7F] hover:text-[#1f487c]  ${canUpdate ? "cursor-pointer" : "cursor-not-allowed"}`}
                                >
                                  Edit
                                </a>
                              </div>
                            </div>
                          ) : (
                            ""
                          )
                        ) : (
                          <div onClick={() => {
                            if(!canUpdate) return;
                            setModalIsOpen(true);
                            SetUpdateData(item.tbs_offer_id);
                            setUsageCount(item?.offerusedcount)
                            handleOptionClick(item.tbs_offer_id);
                          }} className={`flex items-center gap-x-[0.5vw] ${canUpdate ?"cursor-pointer":"cursor-not-allowed"}`}>
                            <div >
                              <MdEdit
                                size={"1.2vw"}
                                color="#1F4B7F"
                                className={`${canUpdate ? "cursor-pointer" : "cursor-not-allowed"}`}
                              />
                            </div>
                            <div>
                              <a

                                className={`flex font-semibold items-center  text-[1vw] text-[#1F4B7F] hover:text-[#1f487c] ${canUpdate ? "cursor-pointer" : "cursor-not-allowed"}`}
                              >
                                Edit
                              </a>
                            </div>
                          </div>
                        )}
                      </span>
                      {/* <a
                        onClick={() => {
                          setModalIsOpen(true);
                          SetUpdateData(item.tbs_offer_id);
                          handleOptionClick(item.tbs_offer_id);
                        }}
                        className="flex font-semibold items-center cursor-pointer text-[1vw] text-[#1F4B7F] hover:text-[#1f487c]"
                      >
                        Edit
                      </a> */}
                    </div>
                    <div onClick={() => {
                      if(!canDelete) return;
                      setDeleteModalIsOpen(true);
                      setPromoId(item);
                      handleOptionClick(item.tbs_offer_id);
                      setValueSymbol("₹");
                    }} className="flex items-center gap-x-[0.5vw] py-[0.25vw]">
                      <span>
                        <MdDelete
                          size={"1.2vw"}
                          color="#1F4B7F"
                          className={`${canDelete ? "cursor-pointer" : "cursor-not-allowed"}`}
                        // onClick={() => {
                        //   handleDelete(row.promo_id);
                        // }}
                        />
                      </span>
                      <a

                        className={`flex font-semibold items-center text-[1vw] text-[#1F4B7F] hover:text-[#1f487c] ${canDelete ? "cursor-pointer" : "cursor-not-allowed"}`}
                      >
                        Delete
                      </a>
                    </div>
                  </div>
                }
                trigger="click"
                open={openPopovers[item.tbs_offer_id] || false} // Open the popover for this specific offerId
                onOpenChange={(visible) => {
                  if (visible) {
                    setOpenPopovers({ [item.tbs_offer_id]: true }); // Open popover for this offerId
                  } else {
                    setOpenPopovers({}); // Close all popovers
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={faEllipsisVertical}
                  color="#1f487c"
                  className={`
                  absolute right-[0.2vw] top-[0.8vw]
                     cursor-pointer rounded-[0.5vw]`}
                  style={{
                    height: "1.5vw",
                    width: "1.5vw",
                  }}
                />
              </Popover>
            </div>
            <div className="flex-col flex items-center  h-full w-full gap-y-[0.1vw]">
              {item.theme ? (
                <img
                  src={
                    item?.offer_img != null ? `${apiImgUrl}${item.theme}` : ""
                  }
                  draggable={false}
                  onClick={() => {
                    setOfferView(item.theme ? true : false);
                    setOfferImage(item.theme);
                    handleOptionClick(item.tbs_offer_id);
                  }}
                  className={`h-[5vw] w-auto rounded-[0.5vw] ${item?.theme ? "cursor-pointer" : ""
                    }`}
                />
              ) : (
                <div className="flex flex-col items-center justify-center w-auto px-[1vw] h-[5vw] ">
                  <CiImageOff size={"3.5vw"} color="#A9A9A9" />
                </div>
              )}

              <div className="flex flex-col w-full items-center justify-center gap-y-[0.25vw] mt-[0.1vw]">
                <div className="font-bold text-[0.9vw] ">{
                  item?.offer_name?.charAt(0) === item?.offer_name?.charAt(0)?.toLowerCase()
                    ? capitalizeFirstLetter(item?.offer_name)
                    : item?.offer_name
                }
                </div>
                <div className="text-[0.9vw] flex">
                  <span className="font-semibold pr-[0.5vw] ">Usage: </span>
                  <span className="">{`${item.offerusedcount}/${item.usage}`}</span>
                </div>
                <div className="text-[0.9vw] flex">
                  <span className="font-semibold pr-[0.5vw] ">
                    Offers Value:{" "}
                  </span>
                  <span className="">
                    {" "}
                    {item?.value_symbol === "₹"
                      ? `${item?.value_symbol} ${item?.offer_value}`
                      : `${item?.offer_value} ${item?.value_symbol}`}
                  </span>
                </div>
                <div className="text-[0.9vw] flex">
                  <span className="font-semibold pr-[0.5vw]">Duration:</span>
                  <span className="">
                    {" "}
                    {`${dayjs(item?.start_date).format("MMM DD")} - ${dayjs(
                      item?.expiry_date
                    ).format("MMM DD")}`}
                  </span>
                </div>
                <div className="px-[0.7vw] w-full">
                  <div
                    className={`${item.req_status_id == 2
                      ? " border-[0.1vw] border-[#34AE2B]"
                      : item.req_status_id == 0
                        ? "border-[0.1vw] border-[#646262]"
                        : item.req_status_id == 3
                          ? "border-[0.1vw] border-[#2A99FF]"
                          : item.req_status_id == 4
                            ? "border-[#FD3434] border-[0.1vw]"
                            : "border-[#FF9900] border-[0.1vw]"
                      } rounded-full `}
                  >
                    <div
                      className={`${item.req_status_id == 2
                        ? "bg-[#34AE2B]"
                        : item.req_status_id == 0
                          ? "bg-[#646262]"
                          : item.req_status_id == 3
                            ? "bg-[#2A99FF]"
                            : item.req_status_id == 4
                              ? "bg-[#FD3434]"
                              : "bg-[#FF9900]"
                        } border-dashed  border-white border-[0.2vw] text-[1.1vw] rounded-full text-white  py-[0.2vw] w-full flex items-center justify-center `}
                    >
                      {item.code}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>):( <div className="grid grid-cols-1 mt-[15vw]">
          
            <div className="col-span-1 flex items-center justify-center text-gray-500">
              <img src={NoData}
            className="w-[3.5vw] h-[3.5vw] "/></div>
            <div className=" col-span-1 flex items-center justify-center font-medium text-[2vw] mt-[0.5vw] text-gray-500 ">
         No Data Found</div>
          </div>)}
      </div>
      <Modal
        visible={offerview}
        onCancel={() => setOfferView(false)}
        footer={null}
        centered
        bodyStyle={{ padding: 0 }}
        destroyOnClose={true}
      >
        <img
          src={offerimage != null ? `${apiImgUrl}${offerimage}` : userimg}
          className="w-full h-full"
        />
      </Modal>
      <ModalPopup
        show={deletemodalIsOpen}
        onClose={closeDeleteModal}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        <DeleteList
          setDeleteModalIsOpen={setDeleteModalIsOpen}
          content={"Want to delete this"}
          title={`${promotionid?.offer_name}`}
          api={`${apiUrl}/offers-deals/${promotionid?.tbs_offer_id}`}
          module={"offer"}
          filter={offerFilter}
        />
      </ModalPopup>
    
    </>
  );
}
